import { MS_TEAMS_WELCOME_FORM_NAME } from 'app/constants/adminMSTeamsWelcome'
import { createRequestActions as request } from 'store/actionCreators/createRequestActions'
import { IAdminMSTeamsWelcome } from './interface'

export const getAdminMSTeamsWelcome = request('ADMIN_MS_TEAMS_WELCOME/GET', (organizationId: number): any => ({
  request: {
    url: `organizations/${organizationId}/ms-teams-welcome`,
    method: 'GET',
  },
  form: MS_TEAMS_WELCOME_FORM_NAME,
}))

export const createAdminMSTeamsWelcome = request(
  'ADMIN_MS_TEAMS_WELCOME/CREATE',
  (data: IAdminMSTeamsWelcome): any => ({
    request: {
      url: `organizations/${data.organizationId}/ms-teams-welcome`,
      method: 'POST',
      data,
    },
    form: MS_TEAMS_WELCOME_FORM_NAME,
    success: 'MS Teams Welcome was successfully created!',
  })
)

export const updateAdminMSTeamsWelcome = request('ADMIN_MS_TEAMS_WELCOME/UPDATE', (data: IAdminMSTeamsWelcome): any => {
  return {
    request: {
      url: `organizations/${data.organizationId}/ms-teams-welcome`,
      method: 'PUT',
      data,
    },
    form: MS_TEAMS_WELCOME_FORM_NAME,
    success: 'MS Teams Welcome was successfully updated!',
  }
})
